import { EnvConfig } from "../../types";

export const customerConfigNp: EnvConfig = {
  MODULE_NAME: "customer",
  MODULE_ENV: "np",
  LD_CLIENT_SIDE_ID: "63583be10d275b11a1f32f7b",
  MANIFEST_URL:
    "https://np-pipelines.app.coxautoinc.com/module-federation.manifest.json"
};
